import React, { ReactElement } from 'react';
import { Entity } from '../../types/entities/Entity';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import { SPTextField } from '../Table/fields/SPTextField';
import { SPSelectField } from '../Table/fields/SPSelectField';
import { enumItems } from '../../schema/enumItems';
import { SPNumberField } from '../Table/fields/SPNumberField';

type Props<T extends Entity> = {
  values: any;
  onChange: (value: any, column: string) => void;
};

export const ServiceReservationFinanceRow = <T extends Entity>({
  values,
  onChange,
}: Props<T>): ReactElement => {
  return (
    <>
      <TableRow>
        <TableCell
          sx={{
            width: '25%',
            background: values?.name_updated_at ? '#ffeda7 !important' : '#fff',

            '& .MuiInputBase-root.MuiOutlinedInput-root': {
              color: values?.name_updated_at && '#66530a !important',
            },
          }}
        >
          <SPTextField
            onChange={(value) => {
              onChange(value, 'name');
            }}
            defaultValue={values['name']}
            isActive={true}
          />
        </TableCell>
        <TableCell
          sx={{
            width: '10%',
            background: values?.paid_by_updated_at
              ? '#ffeda7 !important'
              : '#fff',

            '& .MuiInputBase-root.MuiOutlinedInput-root': {
              color: values?.paid_by_updated_at && '#66530a !important',
            },
          }}
        >
          <SPSelectField
            onChange={(value) => {
              onChange(value, 'paid_by');
            }}
            defaultValue={values['paid_by']}
            accordingToValue={{}}
            schema={enumItems.user}
            forcedValue={{}}
            disabled={false}
            isMissing={false}
          />
        </TableCell>
        <TableCell
          sx={{
            width: '15%',
            '& .MuiFormControl-root.MuiTextField-root input': {
              textAlign: 'right',
            },
            background: values?.gross_cost_updated_at
              ? '#ffeda7 !important'
              : '#fff',

            '& .MuiInputBase-root.MuiOutlinedInput-root': {
              color: values?.gross_cost_updated_at && '#66530a !important',
            },
          }}
        >
          <SPNumberField
            onChange={(value) => {
              onChange(value, 'gross_cost');
            }}
            defaultValue={values['gross_cost']}
            isActive={true}
          />
        </TableCell>
        <TableCell
          sx={{
            width: '8%',
            background: values?.currency_updated_at
              ? '#ffeda7 !important'
              : '#fff',
            '& .MuiInputBase-root.MuiOutlinedInput-root': {
              color: values?.currency_updated_at && '#66530a !important',
            },
          }}
        >
          <SPSelectField
            onChange={(value) => {
              onChange(value, 'currency');
            }}
            defaultValue={values['currency']}
            accordingToValue={{}}
            schema={enumItems.currency}
            forcedValue={{}}
            disabled={false}
            isMissing={false}
          />
        </TableCell>
        <TableCell
          sx={{
            width: '10%',
            '& .MuiFormControl-root.MuiTextField-root input': {
              textAlign: 'right',
            },
            background: values?.vat_updated_at ? '#ffeda7 !important' : '#fff',
            '& .MuiInputBase-root.MuiOutlinedInput-root': {
              color: values?.vat_updated_at && '#66530a !important',
            },
          }}
        >
          <SPNumberField
            onChange={(value) => {
              onChange(value, 'vat');
            }}
            defaultValue={values['vat']}
            isActive={true}
          />
        </TableCell>
        <TableCell
          sx={{
            width: '10%',
            background: values?.ifa_updated_at ? '#ffeda7 !important' : '#fff',
            '& .MuiInputBase-root.MuiOutlinedInput-root': {
              color: values?.ifa_updated_at && '#66530a !important',
            },
          }}
        >
          <SPNumberField
            onChange={(value) => {
              onChange(value, 'ifa');
            }}
            defaultValue={values['ifa']}
            isActive={true}
          />
        </TableCell>
      </TableRow>
    </>
  );
};
